import React from "react";
import Synonyms from "./Synonyms";
import "./Meaning.css";

export default function Meaning(props){
    return (
        <div className="Meaning">
        <h4>
            {props.meaning.partOfSpeech}
        </h4>
        {props.meaning.definitions.map(function(definition, index){
            return(
                <div key={index}>
                <p className="text-justify">
                {definition.definition}
                <br/>
                <em>{definition.example}</em>
                </p>
                <Synonyms synonyms={definition.synonyms} />
                </div>
            )
            })
        }
        </div>
        );
}